/**
 * Canonical `DownloadItem.id`s for the built-in download formats. Centralised
 * so the per-format builders — and anything that keys off the id (menu logic,
 * tests) — reference one source of truth instead of re-typing string literals.
 * The Markdown format keeps the short `'md'` id to match its `.md` extension.
 */
export const DOWNLOAD_ITEM_IDS = {
  png: 'png',
  csv: 'csv',
  markdown: 'md',
} as const

export type DownloadItemId =
  (typeof DOWNLOAD_ITEM_IDS)[keyof typeof DOWNLOAD_ITEM_IDS]
